module.exports = __webpack_public_path__ + "static/media/ascending.0e552fb2.mp4";